"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApiResponse = void 0;
class ApiResponse {
    constructor(obj, data) {
        if (obj.first === 0 || !!obj.first) {
            this.first = obj.first;
        }
        if (obj.total === 0 || !!obj.total) {
            this.total = obj.total;
        }
        this.data = data;
    }
}
exports.ApiResponse = ApiResponse;
//# sourceMappingURL=ApiResponse.js.map